// ie polyfill
import '@babel/polyfill'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { VueAxios } from './utils/request'

import bootstrap from './core/bootstrap'
import './core/use'
import './permission' // permission control
import './utils/filter' // global filter
import configs from '@/config/defaultSettings'

Vue.config.productionTip = false

// mount axios Vue.$http and this.$http
Vue.use(VueAxios)

window.environment = location.host.indexOf('get88') != -1 ? 'bz' : 'jds'
// if (process.env.NODE_ENV == 'production'){
if (process.env.VUE_APP_PREVIEW == 'true') {
  //测试环境
  window.base_url = location.host.indexOf('get88') != -1 ? configs.bztestUrl : configs.testUrl
} else {
  //正式环境
  window.base_url = location.host.indexOf('get88') != -1 ? configs.bzproUrl : configs.proUrl
}
// }

String.prototype.replaceAll = function(source, target) {
  var str = this
  while (str.indexOf(source) > -1) {
    str = str.replace(source, target)
  }
  return str
}

import tinymce from 'tinymce'
import VueTinymce from "@packy-tang/vue-tinymce"
Vue.prototype.$tinymce = tinymce
Vue.use(VueTinymce);

new Vue({
  router,
  store,
  created() {
    bootstrap()
  },
  render: h => h(App)
}).$mount('#app')
